import React, { useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AddOrderForm from "../components/AddOrderForm";
import { validateOrder } from "../utils/validateOrder";
import { ORDER_STATUS } from "../constants/orderStatuses";

function AddOrderPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    location: "",
    categories: [],
    locationOnMap: "",
    notes: "",
    priority: false,
    status: ORDER_STATUS.INIT_MEASURE,
    meters: 0,
    createdAt:""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleCategoriesChange = (categories) => {
    setFormData((prev) => ({
      ...prev,
      categories
    }));
    setErrors((prev) => ({
      ...prev,
      categories: null
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateOrder(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    setIsSubmitting(true);

    try {
      const response = await axiosInstance.post(
        `/orders`,
        formData
      );
      const newOrderId = response.data?.order?.id || response.data?.id;

      toast.success("تم حفظ الطلب بنجاح! ✅");
      navigate(newOrderId ? `/order-details/${newOrderId}` : "/orders");
    } catch (error) {
      if (error.response) {
      const status = error.response.status;
      if (status === 400) {
        toast.error(error.response.data.message || "بيانات غير صحيحة ❌");
      } else if (status === 403) {
        toast.error("ليس لديك صلاحية لإضافة طلب جديد ❌");
      } else if (status === 422) {
        toast.error("البيانات المدخلة غير صالحة ❌");
      }} else if (error.request) {
        toast.error("خطأ في الاتصال بالخادم ⚠️");
      } else {
      console.error(error);
      toast.error("فشل إضافة الطلب ❌");
      }
      setIsSubmitting(false);
    }
  };

  return (
    <AddOrderForm
      formData={formData}
      errors={errors}
      isSubmitting={isSubmitting}
      onChange={handleChange}
      onCategoriesChange={handleCategoriesChange}
      onSubmit={handleSubmit}
    />
  );
}

export default AddOrderPage;
